module.exports = __webpack_public_path__ + "img/io.73761bd.svg";